// export const getAgeCategory = (age) => {
//   if (age <= 8) {
//     return 'Child BVDQ';
//   } else if (age >= 9 && age <= 13) {
//     return 'Youth BVDQ';
//   } else if (age >= 14) {
//     return 'Adult BVDQ';
//   }
// };


// export const getTopSymptoms = (answers) => {

//   const symptoms = [
//     { name: 'Dizziness', value: answers?.dizziness },
//     { name: 'Nausea', value: answers?.nausea },
//     { name: 'Anxiety', value: answers?.anxiety },
//     { name: 'Headaches', value: answers?.headache },
//     { name: 'Neck Pain', value: answers?.neck_pain },
//     { name: 'Unsteady with Walking', value: answers?.balance_issues },
//     { name: 'Sensitivity to Light', value: answers?.light_sensitivity },
//     { name: 'Reading Difficulty', value: answers?.reading_challenges },
//     { name: 'Sound Sensitivity', value: answers?.sound_sensitivity },
//   ];

//   const filtered = symptoms
//     .filter(symptom => symptom.value > 0)
//     .sort((a, b) => b.value - a.value);

//   return filtered.length > 0 ? filtered.slice(0, 3) : [];
// };


// export const convertToUSFormat = (dateString) => {
//   const date = new Date(dateString);

//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
//   const year = date.getFullYear();

//   const hours = String(date.getHours()).padStart(2, '0');
//   const minutes = String(date.getMinutes()).padStart(2, '0');
//   const seconds = String(date.getSeconds()).padStart(2, '0');

//   return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
// };


// export const getChildSection = (score) => {
//   if (score >= 0 && score <= 3) {
//     return { text: "Unlikely", className: "unlikely" };
//   } else if (score >= 4 && score <= 7) {
//     return { text: "Mild", className: "mild" };
//   } else if (score >= 8 && score <= 10) {
//     return { text: "Moderate", className: "moderate" };
//   } else if (score >= 11 && score <= 13) {
//     return { text: "Severe", className: "severe" };
//   }
//   return { text: null, className: "" };
// };

// export const getPreteenSection = (score) => {
//   if (score >= 0 && score <= 9) {
//     return { text: "Unlikely", className: "unlikely" };
//   } else if (score >= 10 && score <= 15) {
//     return { text: "Mild", className: "mild" };
//   } else if (score >= 16 && score <= 25) {
//     return { text: "Moderate", className: "moderate" };
//   } else if (score >= 26 && score <= 48) {
//     return { text: "Severe", className: "severe" };
//   }
//   return { text: null, className: "" };
// };


// export const getAdultSection = (score) => {
//   if (score >= 0 && score <= 14) {
//     return { text: "Unlikely", className: "unlikely" };
//   } else if (score >= 15 && score <= 24) {
//     return { text: "Mild", className: "mild" };
//   } else if (score >= 25 && score <= 39) {
//     return { text: "Moderate", className: "moderate" };
//   } else if (score >= 40 && score <= 75) {
//     return { text: "Severe", className: "severe" };
//   }
//   return { text: null, className: "" };
// };

export const getAgeCategory = (age) => {
  if (age <= 8 || age === "child") {
    return 'Child BVDQ';
  } else if ((age >= 9 && age <= 13) || age === "youth") {
    return 'Youth BVDQ';
  } else if (age >= 14 || age === "adult") {
    return 'Adult BVDQ';
  }
};

// export const getAgeCategory = (age) => {
//   if (age == "child") {
//     return 'Child BVDQ';
//   } else if (age == "youth") {
//     return 'Youth BVDQ';
//   } else if (age == "adult") {
//     return 'Adult BVDQ';
//   }
// };


export const getTopSymptoms = (answers) => {

  const symptoms = [
    { name: 'Dizziness', value: answers?.dizziness },
    { name: 'Nausea', value: answers?.nausea },
    { name: 'Anxiety', value: answers?.anxiety },
    { name: 'Headaches', value: answers?.headache },
    { name: 'Neck Pain', value: answers?.neck_pain },
    { name: 'Unsteady with Walking', value: answers?.balance_issues },
    { name: 'Sensitivity to Light', value: answers?.light_sensitivity },
    { name: 'Reading Difficulty', value: answers?.reading_challenges },
    { name: 'Sound Sensitivity', value: answers?.sound_sensitivity },
  ];

  const filtered = symptoms
    .filter(symptom => symptom.value > 0)
    .sort((a, b) => b.value - a.value);

  return filtered.length > 0 ? filtered.slice(0, 3) : [];
};


export const convertToUSFormat = (dateString) => {
  const date = new Date(dateString);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
};


export const getChildSection = (score) => {
  if (score >= 0 && score <= 3) {
    return { text: "Unlikely", className: "unlikely" };
  } else if (score >= 4 && score <= 7) {
    return { text: "Moderate", className: "mild" };
  } else if (score >= 8 && score <= 10) {
    return { text: "High", className: "moderate" };
  } else if (score >= 11 && score <= 13) {
    return { text: "Severe", className: "severe" };
  }
  return { text: null, className: "" };
};

export const getPreteenSection = (score) => {
  if (score >= 0 && score <= 9) {
    return { text: "Unlikely", className: "unlikely" };
  } else if (score >= 10 && score <= 19) {
    return { text: "Moderate", className: "mild" };
  } else if (score >= 20 && score <= 29) {
    return { text: "High", className: "moderate" };
  } else if (score >= 30 && score <= 48) {
    return { text: "Severe", className: "severe" };
  }
  return { text: null, className: "" };
};


export const getAdultSection = (score) => {
  if (score >= 0 && score <= 14) {
    return { text: "Unlikely", className: "unlikely" };
  } else if (score >= 15 && score <= 30) {
    return { text: "Moderate", className: "mild" };
  } else if (score >= 31 && score <= 45) {
    return { text: "High", className: "moderate" };
  } else if (score >= 46 && score <= 75) {
    return { text: "Severe", className: "severe" };
  }
  return { text: null, className: "" };
};